var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6026 9.64726C12.2869 9.9555 12.1064 10.3991 12.1515 10.8727C12.2192 11.6847 12.9635 12.2786 13.7754 12.2786H15.2038V13.1732C15.2038 14.7295 13.9333 16 12.3771 16H3.74637C2.19013 16 0.919586 14.7295 0.919586 13.1732V8.11358C0.919586 6.55735 2.19013 5.2868 3.74637 5.2868H12.3771C13.9333 5.2868 15.2038 6.55735 15.2038 8.11358V9.19618H13.6852C13.2642 9.19618 12.8808 9.36158 12.6026 9.64726Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.919586 8.79023V5.35448C0.919586 4.45984 1.4684 3.66293 2.3029 3.34717L8.27222 1.09176C8.48851 1.01025 8.72134 0.982452 8.95074 1.01074C9.18013 1.03902 9.39924 1.12255 9.58924 1.25415C9.77925 1.38575 9.93449 1.5615 10.0416 1.7663C10.1488 1.9711 10.2046 2.19884 10.2044 2.42997V5.28682M4.3027 8.48199H9.56532M16 9.96304V11.5118C16 11.9252 15.6692 12.2636 15.2482 12.2786H13.7747C12.9627 12.2786 12.2184 11.6847 12.1508 10.8727C12.1057 10.3991 12.2861 9.95552 12.6019 9.64728C12.88 9.3616 13.2634 9.1962 13.6845 9.1962H15.2482C15.6692 9.21124 16 9.54955 16 9.96304Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.7ea4cc791881293b007f5bc0395af9f7.svg";
export { ForwardRef as ReactComponent };